import React, {useState, useRef} from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Table, Divider, Popconfirm, Typography,Button } from 'antd';
import { useContext } from 'react';
import { ContextAPI } from '../../../../ContextAPI';
import { CheckCircleOutlined, CreditCardOutlined,DownloadOutlined } from "@ant-design/icons";
import { baseUrl } from '../../../../api';
import { ENDPOINT } from '../../../../constants';
import ViewPayments from "../../../paymentModal/ViewPayments";
import LedgerModal from "../../Ledger/LedgerModal";
const {Text} = Typography;
function InvoiceTable(props) {
  const {
    history,
    gst,
    pagination,
    dataSource,
    openPaymentModal,
    spinner,
    setModifyAccess,
    modify,
    deleteData,
    setEditable,
    setEditableData,
    updateJobInvoiceStatus,
    showPaymentActions,
    deleteAccess,
    printAccess
  } = props;
  const { loginCredintials } = useContext(ContextAPI);

  const [receiptsView, setReceiptsView] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);
  const updatingInvoiceIdsRef = useRef(new Set());

const hasCashCollectAccess = () => {
    if (
      loginCredintials?.roleAccess
    ) {
      return loginCredintials.roleAccess.some(
        (acc) =>
          acc.master === "TRANSACTIONMASTER" &&
          (acc.subModule === "Cash Payment" || acc.subModule=="POS Machine") &&
          acc.access.create === true
      );
    }
    return false;
  };

  const column = [
  {
      title:"S.No",
      width:'6%',
      render:(value,data,index)=><span>{(pagination.current-1)*10 + index+1}</span>
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      width:'9%',
      render: (record) => (<span>{moment(new Date(record)).format('DD/MM/YYYY')}</span>),
    },
    {
      title: "Invoice No",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width:'9%',
      render: (record) => (<span>{record}</span>),
    },
    {
      title: "Job Card",
      dataIndex: "jobOrder",
      key: "jobOrder",
      width:'13%',
      render: (record) => (<span>{record && record.jobNo ? record.jobNo : "-"}</span>),
    },
    {
      title: "Party Name",
      dataIndex: "partyName",
      key: "partyName",
      width:'12%',
      render: (party, data) => {
        const customerObj = party || data?.customer || data?.jobOrder?.customer;
        return (
          <span
            className="linkylink"
            onClick={(e) => {
              e.stopPropagation();
              if (customerObj) {
                setSelectedCustomer(customerObj);
                setCustomerLedgerOpen(true);
              }
            }}
          >
            {customerObj?.name || "-"}
          </span>
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "totalInvoice",
      key: "totalInvoice",
      width:'9%',
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Payment Status",
      dataIndex: "jobOrder",
      key: "jobOrder",
      width:'13%',
      render: (record) => (<span>{record && record.jobStatus ? record.jobStatus : "-"}</span>),
    },
    {
      title: <span>Actions</span>,
      key: "actions",
      render: (data) => {
        return <div style={{display: "flex"}}>
          { printAccess && !showPaymentActions ?
            <a href={`${ENDPOINT}api/jobInvoice/generatePDF/${data.id}`} target="_blank" rel="noopener noreferrer" className="linkylink" onClick={(e)=>e.stopPropagation()}>Print</a>
            :
            <span></span>
          }
          { modify?
          <>
          <Divider type="vertical" />
            <span
              onClick={(event) => {
                event.stopPropagation();
                // setModifyAccess(true)
                history.push({
                  pathname: `/autoadmin/job_invoice/${data.id}`,
                  state: {
                    gst: gst,
                    editable: true
                  }
                })
              }}
              className="linkylink"
            >
              Modify
            </span>
          </>
            :
            <span></span>
          }
          { deleteAccess?
            <>
            <Divider type="vertical" />
            <Popconfirm
              title="Do you want to delete SSI?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(data.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
              Delete
              </span>
            </Popconfirm>
            </>
            :
            <span></span>
          }

          {hasCashCollectAccess()  && !showPaymentActions && (
              <>
                <Divider type="vertical" />
                <span className='linkylink' onClick={(e) => {
                  e.stopPropagation();
                  setReceiptsView(true);
                  setSelectedData(data);
                }}>
                  Receipts
                </span>
              </>
            )}

          {hasCashCollectAccess()  && showPaymentActions && (
              <>
                <Divider type="vertical" />
                {data ? (
                  (() => {
                    const payments =data.payment ? Array.isArray(data.payment)
                      ? data.payment
                      : [data.payment] : [];
                      const totalCollected = data.payment ? payments.reduce(
                        (sum, p) => (p.status === "SUCCESS" ? sum + (Number(p.collectedAmount) || 0) : sum),
                        0
                      ) : 0;
                    const billAmount = Number(data.totalInvoice || 0);
                    const remainingAmount = billAmount - totalCollected;
                    const isFullyPaid = totalCollected >= billAmount;
                    const isPartiallyPaid = totalCollected > 0 && !isFullyPaid;

                    if (isFullyPaid) {
                      if (data.jobOrder?.jobStatus !== "PAID" && data.jobOrder?.jobStatus !== "Payment Completed" && !updatingInvoiceIdsRef.current.has(data.id)) {
                        updatingInvoiceIdsRef.current.add(data.id);
                        updateJobInvoiceStatus(data.id);
                      }
                      return (
                      <Button
                          type="primary"
                          icon={<CheckCircleOutlined />}
                          size="small"
                          disabled
                          style={{
                            backgroundColor: "#e0c3e3",
                            borderColor: "#1e0221",
                            color: "black",
                            cursor: "not-allowed",
                            opacity: 1,
                          }}
                        >
                          Payment Completed
                        </Button>
                      );
                    } else {
                      return (
                        <Button
                          type="primary"
                          icon={<CreditCardOutlined />}
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            openPaymentModal(data);
                          }}
                        >
                          {isPartiallyPaid
                            ? `Collect Remaining ₹${remainingAmount}`
                            : "Collect Cash"}
                        </Button>
                      );
                    }
                  })()
                ) : (
                  <Button
                    type="primary"
                    icon={<CreditCardOutlined />}
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      openPaymentModal(data);
                    }}
                  >
                    Collect Cash
                  </Button>
                )}
              </>
            )}
          {
            !modify && !deleteAccess && !printAccess
            ?
            <Text strong disabled>No Actions Given</Text>
            :
            <span></span>
          }
        </div>
      },
    },
  ];

  return (
    <>
    <Table
      rowKey={(record) => record.id}
      pagination={pagination}
      columns={column}
      tableLayout="fixed"
      loading={spinner}
      style={{ cursor: "pointer", overflowX: "scroll", width: "100%" }}
      dataSource={dataSource}
      onRow={(record) => ({
        onClick: () => {
          history.push({
            pathname: `/autoadmin/job_invoice/${record.id}`,
            state: {
              gst: gst
            }
          })
          // history.push(`/autoadmin/sale_spares_invoice/${record.id}`)
        },
      })}
    />

    {
      receiptsView && (
        <ViewPayments
          data = {selectedData?.payment}
          open={receiptsView}
          close={() => setReceiptsView(false)}
          module="jobInvoice"
        />
      )
    }

    {customerLedgerOpen && selectedCustomer && (
      <LedgerModal
        visible={customerLedgerOpen}
        onCancel={() => {
          setCustomerLedgerOpen(false);
          setSelectedCustomer(null);
        }}
        data={selectedCustomer}
        type="CUSTOMERS"
        initialSubTab="JOB_INVOICE"
      />
    )}
    </>
  );
}


export default withRouter(InvoiceTable);